<template>
    <ul class="link-list">
        <li v-for="item in list" :key="item.id" class="link-list--item">
            <!-- <span><i :class="convertToFavicon(item.api)"></i></span> -->
            <span></span>
            <span>{{item.link}}</span>
            <span @click="editItem(item.id)"><i class="fa fa-pencil"></i></span>
        </li>
        <li class="link-list--button" @click="addNewItem">+ Adicionar</li>
    </ul>
</template>

<script>
import apisList from "@/mixins/apisList";
export default {
    props:{
        list:{
            type: Array,
            required: false,
        }
    },
    mixins: [apisList],
    methods:{
        editItem(itemId){
            this.$emit('editItem', itemId)
        },
        addNewItem(){
            this.$emit('addNewItem');
        },
        convertToFavicon(value){
            const apiActive = this.integrationsOptions.find(item => item.id == value);
            return `fab fa-${apiActive.name.toLowerCase()}`
        }
    }
}
</script>

<style scoped>
.link-list{
    margin: 0;
    padding: 0;
    color: #7E7E7E;
}
.link-list :last-child{
    text-align: center;
    cursor: pointer;
    list-style: none;
    padding: 8px 0;
}
.link-list--item{
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid rgba(112, 112, 112, .33);
}
.link-list--item :first-child{
    margin-right: 10px;
}
.link-list--item :nth-child(2){
    word-break: break-all;
}
.link-list--item :last-child{
    margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/CustomIntegrationsList.vue